// @ts-check

import { useEffect, useState } from "react"

export default function useIsHoldingModifierDown() {
  const [isHoldingModifier, setIsHoldingModifier] = useState(false)

  /** @param {KeyboardEvent} e */
  function handleKeyDown(e) {
    if (e.ctrlKey || e.metaKey) {
      setIsHoldingModifier(true)
    }
  }

  /** @param {KeyboardEvent} e */
  function handleKeyUp(e) {
    if (!e.ctrlKey && !e.metaKey) {
      setIsHoldingModifier(false)
    }
  }

  function browserHasLostFocus() {
    setIsHoldingModifier(false)
  }

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown)
    window.addEventListener("keyup", handleKeyUp)
    window.addEventListener("blur", browserHasLostFocus)
    window.addEventListener("focus", browserHasLostFocus)
    return () => {
      window.removeEventListener("keydown", handleKeyDown)
      window.removeEventListener("keyup", handleKeyUp)
      window.removeEventListener("blur", browserHasLostFocus)
      window.removeEventListener("focus", browserHasLostFocus)
    }
  }, [])
  return isHoldingModifier
}
